<template>
  <div :class="statusClass" class="status-badge">
    <span class="dot"></span>
    <span>{{ statusText }}</span>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "BadgeProdutosAtivos",
  props: {
    value: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const statusText = computed(() => {
      return props.value === "A" ? "Ativo" : "Inativo";
    });

    const statusClass = computed(() => {
      return props.value === "A" ? "ativo" : "inativo";
    });

    return { statusText, statusClass };
  }
});
</script>

<style scoped>
.status-badge {
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  font-weight: 400;
}

.status-badge .dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 8px;
}

.ativo {
  background-color: #c8f7dc;
  color: #000;
  padding: 6px 22px 6px 12px;
}
.ativo .dot {
  background-color: #2ecc71;
}

.inativo {
  background-color: #ffd6d6;
  color: #000;
  padding: 6px 12px;
}
.inativo .dot {
  background-color: #ff3b3b;
}
</style>
